import { useState, useEffect } from "react";
import BASE_URL from "../assets/global/url";
import { useServerPagination } from "./customHook/paginationHook/useServerPagination";

const useAccountsData = (searchTerm = "") => {
  const pagination = useServerPagination(
    `${BASE_URL}/bankBudgeting/getAllSubject3`,
    10,
  );

  useEffect(() => {
    if (searchTerm.trim() === "") {
      pagination.updateApiUrl(`${BASE_URL}/bankBudgeting/getAllSubject3`);
      pagination.updateParams({});
    } else {
      pagination.updateApiUrl(
        `${BASE_URL}/bankBudgeting/getAllSubject3/search`,
      );
      pagination.updateParams({ searchText: searchTerm });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTerm]);

  return { accountsData: pagination };
};

export default useAccountsData;
